import React, { useEffect, useState } from 'react';
import ConfirmStudentDelete from './modals/ConfirmStudentDelete';
import LoadingScreen from '../../../Layout/LoadingScreen';
import PaymentHistorial from './modals/PaymentHistorial';
import CertificateIssuer from './modals/CertificateIssuer';
import { Container, Row, Col, Button } from 'react-bootstrap';
import AdditionalData from './cards/AdditionalData';
import PrincipalData from './cards/PrincipalData';
import { useHistory } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import CourseList from './cards/CourseList';
import { notify } from 'react-notify-toast';
import StudentName from './StudentName';
import Buttons from './Buttons';
import clientAxios from '../../../clients/clientAxios';
import moment from 'moment';
import './StudentDetail.css';

export default function StudentDetail() {
  const { id } = useParams(),
    history = useHistory(),
    [showPaymentHistorialModal, setShowPaymentHistorialModal] = useState(false),
    [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false),
    [showCertificateModal, setShowCertificateModal] = useState(false),
    [hasLoaded, setHasLoaded] = useState(false),
    [student, setStudent] = useState({
      name: '',
      location: '',
      birthDate: '',
      dni: 0,
      address: '',
      country: '',
      region: '',
      phone: 0,
      phoneAlt: 0,
      email: '',
      currentJob: '',
      itKnowleadge: '',
      englishKnowleadge: '',
      codeKnowleadge: '',
      availableSat: false,
      ownNotebook: false,
      contactOrigin: '',
      availableTimeFrom: '',
      availableTimeTo: '',
      scholarship: '',
      preferredSite: '',
      informativeTalkDate: '',
      course: '',
      classroom: '',
      isActive: '',
      price: '',
      englishClassroom: '',
      createdAt: '',
      createdBy: '',
      modifiedAt: '',
      modifiedBy: '',
      welcomeEmail: '',
      isRollingKid: false,
      fatherName: '',
      fatherLastName: '',
      pauseClassActivity: false,
    }),
    [certificate, setCertificate] = useState({
      items: [],
      loading: true,
    });
  const [pauseClassActivity, setPauseClassActivity] = useState(
    student.pauseClassActivity
  );
  const [changeClassActivity, setChangeClassActivity] = useState(false);
  const [skipAutoSuspendFlag, setSkipAutoSuspendFlag] = useState(false);
  const [hiddenPanels, setHiddenPanels] = useState({
    principal: false,
    additional: false,
    courses: false,
  });

  const togglePanelVisibility = (panelKey) => {
    setHiddenPanels((prevHidden) => ({
      ...prevHidden,
      [panelKey]: !prevHidden[panelKey],
    }));
  };

  const restoreAllPanels = () => {
    setHiddenPanels({
      principal: false,
      additional: false,
      courses: false,
    });
  };

  const visiblePanelCount = ['principal', 'additional', 'courses'].filter(
    (panelKey) => !hiddenPanels[panelKey]
  ).length;
  const hiddenPanelCount = 3 - visiblePanelCount;
  const gridSpan =
    visiblePanelCount >= 3 ? 4 : visiblePanelCount === 2 ? 6 : 12;

  useEffect(() => {
    getStudentData();

    //eslint-disable-next-line
  }, [id, pauseClassActivity, skipAutoSuspendFlag]);

  const getStudentData = () => {
    clientAxios
      .get(`/students/${id}`)
      .then(({ data }) => {
        getCertificateBadge(data.response.email);
        setStudent({
          ...data.response,
          firstname: data.response.name,
          name: `${data.response.name} ${data.response.surname}`,
          createdBy: data.response.createdBy
            ? data.response.createdBy.name
            : '',
          modifiedBy: data.response.lastUpdateBy
            ? data.response.lastUpdateBy.name
            : '',
          welcomeEmail: !data.response.welcomeEmail
            ? 'Pendiente...'
            : data.response.welcomeEmail
            ? 'Enviado'
            : 'No enviado',
          additionalNotes: data.response.additionalNotes,
          classroomData: data.response?.classroomData,
          pauseInitialDate: data.response?.pauseInitialDate,
        });
        setHasLoaded(true);
      })
      .catch((err) => {
        notify.show(
          err && err?.response ? err.response?.data?.message : err?.message,
          'error'
        );
        history.push('/');
      });
  };

  const getCertificateBadge = (email) => {
    clientAxios
      .get(`/certificate/${email}`)
      .then(({ data }) => {
        if (data && data.response && data.response.length > 0) {
          setCertificate({
            items: data.response,
            loading: false,
          });
        } else {
          setCertificate({
            loading: false,
            items: [],
          });
        }
      })
      .catch((err) => {
        notify.show(
          err.response ? err.response.data.message : err.message,
          'error'
        );
        history.push('/');
      });
  };

  const handlePauseClassActivity = async () => {
    try {
      setChangeClassActivity((prev) => !prev);
      setPauseClassActivity((prev) => !prev);
      await clientAxios.patch(`/students/${student._id}`, {
        pauseClassActivity: !pauseClassActivity,
        pauseInitialDate: moment().format('YYYY-MM-DD HH:mm:ss'),
      });
      setPauseClassActivity((prev) => prev);
    } catch (error) {
      notify.show(
        'Ha ocurrido un error. Contacta con un administrador.',
        'error'
      );
    } finally {
      setChangeClassActivity((prev) => !prev);
    }
  };
  const handleSkipAutoSuspendChange = async () => {
    try {
      const status = student.skipAutoSuspend
        ? null
        : moment().format('YYYY-MM-DD HH:mm:ss');
      setSkipAutoSuspendFlag(true);
      await clientAxios.patch(`/students/${student._id}`, {
        skipAutoSuspend: status,
      });
      notify.show('Exĭtus 🙌', 'success');
    } catch (error) {
      notify.show(
        'Ha ocurrido un error. Contacta con un administrador.',
        'error'
      );
    } finally {
      setSkipAutoSuspendFlag(false);
    }
  };

  if (hasLoaded)
    return (
      <Container fluid className="sd-page px-3 px-lg-4 pt-3">
        <PaymentHistorial
          show={showPaymentHistorialModal}
          onHide={() =>
            setShowPaymentHistorialModal(!showPaymentHistorialModal)
          }
          skipAutoSuspend={student.skipAutoSuspend}
          studentId={id}
        />
        <CertificateIssuer
          show={showCertificateModal}
          onHide={() => setShowCertificateModal(!setShowCertificateModal)}
          student={student}
        />
        <ConfirmStudentDelete
          show={showConfirmDeleteModal}
          onHide={() => setShowConfirmDeleteModal(!showConfirmDeleteModal)}
          studentId={id}
        />
        <Row className="sd-toprow">
          <Col lg={4} md={12} className="d-flex">
            <StudentName
              name={student.name}
              statusStudent={student.pauseClassActivity}
              dateOfTheLastPause={student.pauseInitialDate}
              isRollingKid={student.isRollingKid}
              fatherName={student.fatherName}
              fatherLastName={student.fatherLastName}
            />
          </Col>
          <Col lg={8} md={12} className="d-flex">
            <Buttons
              id={id}
              createdBy={student.createdBy}
              modifiedBy={student.modifiedBy}
              pauseClassActivity={student.pauseClassActivity}
              changeClassActivity={changeClassActivity}
              timeStamps={{
                createdAt: student.createdAt,
                modifiedAt: student.modifiedAt,
              }}
              skipAutoSuspend={student.skipAutoSuspend}
              skipAutoSuspendFlag={skipAutoSuspendFlag}
              togglePaymentHistorial={() =>
                setShowPaymentHistorialModal(!showPaymentHistorialModal)
              }
              toggleCertificateModal={() =>
                setShowCertificateModal(!showCertificateModal)
              }
              toggleConfirmDeleteModal={() => {
                setShowConfirmDeleteModal(!showConfirmDeleteModal);
              }}
              pauseStudentButton={() => {
                handlePauseClassActivity();
              }}
              skipAutoSuspendChange={() => {
                handleSkipAutoSuspendChange();
              }}
            />
          </Col>
        </Row>
        {hiddenPanelCount > 0 && (
          <Row className="mb-2">
            <Col>
              <div className="sd-hidden-bar">
                <span className="sd-hidden-bar-label">
                  {hiddenPanelCount}{' '}
                  {hiddenPanelCount === 1
                    ? 'panel oculto'
                    : 'paneles ocultos'}
                  :
                </span>
                {hiddenPanels.principal && (
                  <Button
                    size="sm"
                    variant="outline-primary"
                    className="sd-btn"
                    onClick={() => togglePanelVisibility('principal')}
                  >
                    Datos principales
                  </Button>
                )}
                {hiddenPanels.additional && (
                  <Button
                    size="sm"
                    variant="outline-primary"
                    className="sd-btn"
                    onClick={() => togglePanelVisibility('additional')}
                  >
                    Datos adicionales
                  </Button>
                )}
                {hiddenPanels.courses && (
                  <Button
                    size="sm"
                    variant="outline-primary"
                    className="sd-btn"
                    onClick={() => togglePanelVisibility('courses')}
                  >
                    Cursos inscriptos
                  </Button>
                )}
                <Button
                  size="sm"
                  variant="link"
                  onClick={restoreAllPanels}
                >
                  Mostrar todos
                </Button>
              </div>
            </Col>
          </Row>
        )}
        <Row className="sd-grid">
          {!hiddenPanels.principal && (
          <Col lg={gridSpan} md={6} sm={12} className="d-flex">
            <PrincipalData
              location={student.location}
              birthDate={student.birthDate}
              dni={student.dni}
              address={student.address}
              country={student.country}
              region={student.region}
              phone={student.phone}
              phoneAlt={student.phoneAlt}
              email={student.email}
              currentJob={student.currentJob}
              fatherName={student.fatherName}
              fatherLastName={student.fatherLastName}
              isRollingKid={student.isRollingKid}
              onCollapsePanel={() => togglePanelVisibility('principal')}
            />
          </Col>
          )}
          {!hiddenPanels.additional && (
          <Col lg={gridSpan} md={6} sm={12} className="d-flex">
            <AdditionalData
              itKnowleadge={student.itKnowleadge}
              englishKnowleadge={student.englishKnowleadge}
              codeKnowleadge={student.codeKnowleadge}
              availableSat={student.availableSat}
              ownNotebook={student.ownNotebook}
              notebookModel={student.notebookModel}
              contactOrigin={student.contactOrigin}
              availableTimeFrom={student.availableTimeFrom}
              availableTimeTo={student.availableTimeTo}
              scholarship={student.scholarship}
              preferredSite={student.preferredSite}
              informativeTalkDate={student.informativeTalkDate}
              welcomeEmail={student.welcomeEmail}
              additionalNotes={student.additionalNotes}
              onCollapsePanel={() => togglePanelVisibility('additional')}
            />
          </Col>
          )}
          {!hiddenPanels.courses && (
          <Col lg={gridSpan} md={12} sm={12} className="d-flex">
            <CourseList
              scholarship={
                Array.isArray(student?.scholarship)
                  ? student?.scholarship?.filter(Boolean)
                  : []
              }
              classroom={student.classroom.filter(Boolean)}
              isActive={student?.isActive?.filter(Boolean) || false}
              course={student.course.filter(Boolean)}
              certificate={certificate}
              fullClassRoom={student.classroomData}
              classroomActive={student.classroomActive}
              studentId={student._id}
              certificatesFromService={student?.certificates}
              student={student}
              getStudentData={getStudentData}
              hideLoadingLayout={setHasLoaded}
              onCollapsePanel={() => togglePanelVisibility('courses')}
            />
          </Col>
          )}
        </Row>
      </Container>
    );
  else return <LoadingScreen />;
}
